import React from 'react';
import FAutoCombo from './FAutoCombo';
import { AutoComboWrapperProps } from './autoCombo.models';

class AutoIdCombo extends React.PureComponent<AutoComboWrapperProps> {
  render() {
    return <FAutoCombo {...this.props} valueMode="id" />;
  }
}

export default AutoIdCombo;
